module.exports = __webpack_public_path__ + "img/VPC_Info.18f542d.svg";